
export const ErrorHandler = {
  enqueueError(error, enqueue) {
    console.error(error);
    enqueue(
        typeof error === 'string' ? error : "An error occurred" ,
        {variant: 'error'}
    );
  }
}